export default __webpack_public_path__ + "static/media/Deposit.58f9a7c2.png";